import React, { Component } from "react";
import { connect } from "react-redux";
import Helping from "../../helpers/Helping";
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import { getSummary, getStats } from '../../services/dashboard_summary.service';
import Notification from "../layout/Notification";
import { ROLE } from '../../config/index';
import Chart from "react-apexcharts";
import jQuery from "jquery";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: URL,
      users_type: props.type,
      isAdmin: false
    };
  }

  setErrorOnApiCall = () => {
    setProfileError(res => this.setState({ ...res }));
  }

  removeNetworkError = () => {
    this.setState({ ...Helping.clearNetworkRequest() });
  }

  componentDidMount() {
    if (jQuery.isEmptyObject(this.props.user_stats)) {
      this.getUserStats();
    }
    this.setErrorOnApiCall();
  }

  handleChangeUsersType(e) {
    this.setState({
      users_type: e.target.id
    }, () =>
      this.getUserStats()
    );
  }

  getUserStats = () => {
    this.props.getStats(this.state.users_type);
  }

  render() {
    const role_access = !Array.isArray(this.props.profile) && this.props.profile.role_access.length > 0 ? JSON.parse(this.props.profile.role_access) : {};
    const { summary, user_stats } = this.props;

    if (role_access.role && role_access.role.toLowerCase() === ROLE.ADMIN.toLowerCase() && !this.state.isAdmin) {
      this.setState({ isAdmin: true });

      if (jQuery.isEmptyObject(this.props.summary)) {
        this.props.getSummary();
      }
    }
    console.log(this.state.users_type);
    console.log(this.props.type);
    console.log(this.props);
    return (
      <div class="content dasboard">
        {this.state.error_message && (
          <Notification
            type={this.state.error_type}
            message={this.state.error_message}
            callback={this.removeNetworkError}
          />
        )}

        <div class="top-header">
          <div class="header-title">
            <h2 class="title">Dashboard</h2>
            <span class="title-caption">Whole data about your business here</span>
          </div>
        </div>

        <div class="main-content">
          {this.state.isAdmin && (
            <div class="row">
              <div class="col-md-6 col-lg-3 mb-4">
                <div class="card h-100">
                  <div class="card-body d-flex align-items-center">
                    <div class="card-left-content">
                      <h4 class="card-title mb-4">Total Sale</h4>

                      <h2 class="card-counter">${summary ? summary.sale : 0}</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-3 mb-4">
                <div class="card h-100">
                  <div class="card-body d-flex align-items-center">
                    <div class="card-left-content">
                      <h4 class="card-title mb-4">Total TV Users</h4>

                      <h2 class="card-counter">{summary ? summary.users : 0}</h2>
                      {/* <span class="percentage plus">+ 10%</span> */}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-3 mb-4">
                <div class="card h-100">
                  <div class="card-body d-flex align-items-center">
                    <div class="card-left-content">
                      <h4 class="card-title mb-4">Total NFTs</h4>

                      <h2 class="card-counter">{summary ? summary.nfts : 0}</h2>
                      {/* <span class="percentage plus">+ 9%</span> */}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-3 mb-4">
                <div class="card h-100">
                  <div class="card-body d-flex align-items-center">
                    <div class="card-left-content">
                      <h4 class="card-title mb-4">Wallet</h4>

                      <h2 class="card-counter">${summary ? summary.wallet : 0}</h2>
                      {/* <span class="percentage minus ">- 3%</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div class="row">
            <div class="col-md-12 col-lg-12 mb-4 ">
              <div class="card h-100 sales-card">
                <div class="card-header card-top">
                  <h4 class="card-title">Users Stats</h4>
                  <div class="sales-tabs">
                    <ul class="nav nav-pills">
                      <li class="tab-item">
                        <a href="#weekly" class={this.state.users_type === "weekly" ? 'active' : ''} id="weekly" data-toggle="tab" onClick={((e) => this.handleChangeUsersType(e))}>Weekly</a>
                      </li>
                      <li class="tab-item">
                        <a href="#monthly" class={this.state.users_type === "monthly" ? 'active' : ''} data-toggle="tab" id="monthly" onClick={((e) => this.handleChangeUsersType(e))}>Monthly</a>
                      </li>
                      <li class="tab-item">
                        <a href="#yearly" class={this.state.users_type === "yearly" ? 'active' : ''} data-toggle="tab" id="yearly" onClick={((e) => this.handleChangeUsersType(e))}>Yearly</a>
                      </li>
                    </ul>
                  </div>
                </div>
                {!jQuery.isEmptyObject(user_stats) && (
                  <div class="card-body card-bottom">
                    <div class="tab-content">
                      <div id="chart">
                        <div class="chart" id="salesChartWeekly">
                          <Chart options={user_stats.options} series={user_stats.series} type="bar" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    profile: state.profile,
    summary: state.summary,
    user_stats: state.user_stats,
    type: state.userStatsMeta.user_type
  }
}

const mapDispatchToProps = {
  addCurrentRoute,
  getStats,
  getSummary
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)